export const systemRu = {
  // Юридическая страница
  'system.legal.fallbackTitle': 'Документ',
  'system.legal.fallbackBody': 'Не найдено.',
  'system.legal.lastUpdated': 'Последнее обновление {date}',

  // Страница "Не найдено"
  'system.notFound.seoTitle': 'Потеряны в Завесе',
  'system.notFound.heading': 'Ты завернул за край карты',
  'system.notFound.body': 'Путь, который ты ищешь, поглощен вечной сумеркой.',
  'system.notFound.returnCta': 'Вернуться в Завесу',

  // Граница обработки ошибок маршрута
  'system.error.unknownDisturbance': 'Неизвестное возмущение потрясло Завесу.',
  'system.error.seoTitle': 'Возмущение в Завесе',
  'system.error.heading': 'Ритуал дал сбой',
  'system.error.body':
    'Что-то невидимое нарушило эту страницу. Завеса здесь тонка — попробуй снова или вернись на безопасную территорию.',
  'system.error.tryAgain': 'Попробовать снова',
  'system.error.returnCta': 'Вернуться в Завесу',
  'licenseGate.heading': "Скоро — ограничено лицензией",
  'licenseGate.body': "Эта языковая версия пока недоступна по лицензионным причинам. Она уже в пути — загляните позже.",
} as const
